export const QUICK_LIST_PRODUCT_CUSTOM_LIST_TYPE_ID =
  '8277F210-DAA8-11EC-9D64-0242AC120002'

export const QUICK_LIST_BATCH_TEMPLATE_ID = '6a84e45581d9ae4b1053ed9c'

export const BATCH_ENTITY_TYPE = 'batch'

export const BATCH_TENANT_ID = 2

export const BATCH_ENTITY_ID = '12cb98a4-a5d6-436f-b941-731c92f97796'

export const QUICK_LIST_PAGE_SIZE_OPTIONS = [10, 20, 30, 50]

export const QUICK_LIST_ROUTES = {
  CREATE: '/settings/quicklist/information',
  EDIT: id => `/settings/quicklist/information/${id}`,
  CATALOG: id => `/settings/quicklist/catalog/${id}`,
}
